import React from 'react'

const MapProduct = () => {
  return (
    <div>MapProduct</div>
  )
}

export default MapProduct